import React from 'react';
import { Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import UserLists from './components/UserLists';

const Users = () => {
  const userdata = JSON.parse(localStorage.getItem('userData'));
  if (['1', '5'].indexOf(userdata.type) === -1) { // not admin
    return (<Redirect to="/dashboard" />);
  }

  return (
    <Container>
      <Row>
        <UserLists />
      </Row>
    </Container>
  );
};

export default Users;
